module.exports = __webpack_public_path__ + "img/worship.838ced53.jpg";